export default class Secao {
  constructor(id, idFormulario, idSecaoTipo, titulo, linhas, colunas, elementos) {
    this.id = id
    this.idFormulario = idFormulario
    this.idSecaoTipo = idSecaoTipo
    this.titulo = titulo
    this.linhas = linhas
    this.colunas = colunas
    this.elementos = elementos
  }
}
